import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "questionnaires-dashboard";

const keys = addTranslations(RESOURCE_NAME, {
    page_title: {
        en: "Fill out your questionnaires faster and easier",
        fr: "Remplissez vos questionnaires plus rapidement et plus facilement",
    },
    page_subtitle: {
        en: "Save valuable time on questionnaires with smart tools that leverage your existing content for faster responses",
        fr: "Gagnez du temps sur les questionnaires avec des outils intelligents qui exploitent votre contenu existant pour des réponses plus rapides",
    },
    recommended_actions_title: {
        en: "Recommended actions",
        fr: "Actions recommandées",
    },
    quick_answer_card_title: {
        en: "Get a quick answer",
        fr: "Obtenir une réponse rapide",
    },
    quick_answer_card_description: {
        en: "Copy-paste a question from a questionnaire and our AI will generate a response.",
        fr: "Copiez-collez une question d'un questionnaire et notre IA générera une réponse.",
    },
    upload_file_card_title: {
        en: "Upload a questionnaire",
        fr: "Téléverser un questionnaire",
    },
    upload_file_card_description: {
        en: "Upload a file and our AI will extract its questions to use within Ditto.",
        fr: "Téléversez un fichier et notre IA extraira ses questions pour l'utiliser dans Ditto.",
    },
    upload_file_card_button_label: {
        en: "Upload questionnaire",
        fr: "Téléverser un questionnaire",
    },
    upload_questions_modal_trigger: {
        en: "Upload questionnaire",
        fr: "Importer un questionnaire",
    },
    upload_file_modal_title: {
        en: "Create a questionnaire from an uploaded file",
        fr: "Créer un questionnaire à partir d'un fichier téléchargé",
    },
    upload_file_modal_button_label: {
        en: "Browse",
        fr: "Parcourir",
    },
    upload_file_modal_placeholder: {
        en: "Upload your questionnaire",
        fr: "Téléversez votre questionnaire",
    },
    upload_file_modal_accepted_file_types: {
        en: "We accept pdf, excel and docx files",
        fr: "Nous acceptons les fichiers pdf, excel et docx",
    },
    analyzing_file: {
        en: "Analyzing file...",
        fr: "Analyse du fichier...",
    },
    template_card_title: {
        en: "Create a questionnaire from a template",
        fr: "Créer un questionnaire à partir d'un modèle",
    },
    template_card_description: {
        en: "Create a questionnaire from the template {{templateName}}.",
        fr: "Créer un questionnaire à partir du template {{templateName}}.",
    },
    all_templates_card_description: {
        en: "Select a template from our library as a starting point to build a custom questionnaire.",
        fr: "Sélectionnez un modèle de notre bibliothèque comme point de départ pour créer un questionnaire personnalisé.",
    },
    template_card_button_label: {
        en: "Choose template",
        fr: "Choisir un modèle",
    },
});
export function useQuestionnairesDashboardTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
